import React from "react";

import PropTypes from "prop-types";

import { Button } from "components/ui/source";

import styles from "../ActionsContainer.module.scss";

function FindYourReservation({
  confirmationPopupClosed,
  openConfirmationPopup,
  closeConfirmationPopup,
  inUserActions,
}) {
  const validProps = () =>
    confirmationPopupClosed !== null &&
    closeConfirmationPopup !== null &&
    openConfirmationPopup !== null;

  if (!validProps()) {
    return null;
  }

  return (
    <>
      {inUserActions ? (
        <li
          className={styles.user_action}
          onClick={openConfirmationPopup}
          onKeyDown={openConfirmationPopup}
        >
          <Button
            type="no_background"
            className={styles.user_action_text}
            textProps={{
              translateKey: "navbar.findYourReservation",
              types: ["body1", "light"],
            }}
          />
        </li>
      ) : (
        <Button
          type="navbar_signup"
          onClick={openConfirmationPopup}
          textProps={{
            translateKey: "navbar.findYourReservation",
            types: ["body1", "light", "inline"],
          }}
          upperCase={false}
        />
      )}
    </>
  );
}

FindYourReservation.propTypes = {
  confirmationPopupClosed: PropTypes.bool,
  openConfirmationPopup: PropTypes.func,
  closeConfirmationPopup: PropTypes.func,
  isMobile: PropTypes.bool,
  openSignUpPopup: PropTypes.func,
  inUserActions: PropTypes.bool,
};

FindYourReservation.defaultProps = {
  confirmationPopupClosed: null,
  openConfirmationPopup: null,
  closeConfirmationPopup: null,
  isMobile: false,
  openSignUpPopup: () => {},
  inUserActions: false,
};

FindYourReservation.displayName = "FindYourReservation";

export default FindYourReservation;
